import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { Store} from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractEffects } from '../../../shared/abstract.effects';
import {
  ELandLineProceduresActions,
  GetLandLineProcedures,
  GetLandLineProceduresFailure,
  GetLandLineProceduresSuccess
} from '../actions/land-line-procedures.actions';
import { LandLineProcedureInterface } from '../../models/land-line-procedure.interface';
import { LandLineProcedureService } from '../../services/land-line-procedure.service';

@Injectable()
export class LandLineProceduresEffects extends AbstractEffects {

    landline: string = null;

    constructor(
        private actions: Actions,
        private landLineProcedureService: LandLineProcedureService,
        public override store: Store<any>
    ) {
        super(store);
    }

    getLandlineProcedures = createEffect(() => this.actions.pipe(
        ofType<GetLandLineProcedures>(ELandLineProceduresActions.GetLandLineProcedures),
        tap(params => { this.landline = params.landline; }),
        switchMap(() => this.landLineProcedureService.get(this.landline)),
        switchMap((response: Array<LandLineProcedureInterface>) => of(new GetLandLineProceduresSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetLandLineProcedures(this.landline));
            } else if (500 <= error.status) {
                this.DisplayMessage('error_with_retry', 400, new GetLandLineProceduresFailure());
            }
            return throwError(error);
        })
    ));
}
